"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = exports.LeaderBoard = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _UserAvatar = _interopRequireDefault(require("../User/UserAvatar"));

var _trackingLink = _interopRequireDefault(require("../link/tracking-link"));

var _widgetContainer = _interopRequireWildcard(require("@insided/deprecated-preact-components/widget-container"));

var _classnames = _interopRequireDefault(require("classnames"));

var _axios = _interopRequireDefault(require("axios"));

var _zod = require("zod");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var widgetName = 'most_liked';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-most_liked';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  amount: _zod.z.number(),
  period: _zod.z.number(),
  title: _zod.z.string()
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;

var LeaderBoard = function LeaderBoard(_ref) {
  var leaderboard = _ref.leaderboard;
  if (!(leaderboard !== null && leaderboard !== void 0 && leaderboard.length)) return null;
  return (0, _preact.h)("ul", {
    className: (0, _classnames.default)('list', 'list--userlikes', 'qa-most-liked-post')
  }, leaderboard.map(function (_ref2, i) {
    var author = _ref2.author,
        likes = _ref2.likes;
    return (0, _preact.h)("li", {
      key: i
    }, (0, _preact.h)("div", {
      className: (0, _classnames.default)('user', 'flag', 'flag--top')
    }, (0, _preact.h)("div", {
      className: "flag__image "
    }, (0, _preact.h)(_UserAvatar.default, {
      user: author,
      showRank: true
    })), (0, _preact.h)("div", {
      className: "user_data flag__body"
    }, (0, _preact.h)(_trackingLink.default, {
      className: "link username",
      href: (0, _absoluteUrlRuntime.resolveUrl)(author.url),
      track: {
        type: 'Sidebar Widget Clicked',
        widget: 'leaderboard'
      },
      gaEvents: {
        eventCategory: 'Homepage',
        eventAction: 'Widget Clicked',
        eventLabel: {
          Type: 'leaderboard'
        }
      }
    }, author.name), (0, _preact.h)("p", {
      className: "text--meta"
    }, (0, _preact.h)(_phrase.default, {
      p: "{n} like.single|{n} like.plural",
      count: {
        n: likes
      }
    })))));
  }));
};

exports.LeaderBoard = LeaderBoard;

var LeaderBoardDataFetcher = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LeaderBoardDataFetcher, _Component);

  var _super = _createSuper(LeaderBoardDataFetcher);

  function LeaderBoardDataFetcher(props) {
    var _this;

    (0, _classCallCheck2.default)(this, LeaderBoardDataFetcher);
    _this = _super.call(this, props);
    _this.state = {
      leaderboard: []
    };
    return _this;
  }

  (0, _createClass2.default)(LeaderBoardDataFetcher, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _yield$axios$get, data;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _axios.default.get('/widget/getLeaderBoard', {
                  params: {
                    period: this.props.period,
                    maxResults: this.props.amount
                  }
                });

              case 2:
                _yield$axios$get = _context.sent;
                data = _yield$axios$get.data;
                this.setState({
                  leaderboard: data.items
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var leaderboard = this.state.leaderboard;
      if (!leaderboard.length) return null;
      var config = this.props.config;
      var classNames = 'box widget widget--likedusers qa-widget-most-liked';
      return (0, _preact.h)(_widgetContainer.default, {
        widgetName: widgetName,
        config: config,
        className: classNames
      }, (0, _preact.h)(LeaderBoard, {
        leaderboard: leaderboard
      }));
    }
  }]);
  return LeaderBoardDataFetcher;
}(_preact.Component);

var _default = LeaderBoardDataFetcher;
exports.default = _default;